// extracted by mini-css-extract-plugin
module.exports = {"nav":"styles_nav__XXnLr","link":"styles_link__3Bmqw","content":"styles_content__GqJWD"};